import { useMemo } from 'react';
import { usePropertyManagers } from './use-property-managers';

function usePropertyManager(propertyManagerId: number | string | null) {
    const propertyManagerQuery = usePropertyManagers();

    const foundPropertyManager = useMemo(() => {
        if (propertyManagerId === null) {
            return null;
        }

        if (propertyManagerQuery.isLoading) {
            return null;
        }

        return propertyManagerQuery.data?.find(
            (propertyManager) => propertyManager.id === propertyManagerId?.toString()
        ) ?? null;
    }, [propertyManagerId, propertyManagerQuery.data, propertyManagerQuery.isLoading]);

    return {
        propertyManager: foundPropertyManager,
        isLoading: propertyManagerQuery.isLoading,
    };
}

export { usePropertyManager };
